// Preferência de experiência (nova tela "Visão geral") + rollout A/B.
//
// Decisão de qual tela mostrar:
//   1. Preferência explícita (opt-in/opt-out) sempre vence: "new" / "old".
//   2. Sem preferência → entra no rollout A/B: bucket estável por navegador
//      comparado ao percentual de rollout.
export const OVERVIEW_EXPERIENCE_KEY = "kf_overview_experience";
const OVERVIEW_AB_BUCKET_KEY = "kf_overview_ab_bucket";

// Percentual de usuários (sem preferência explícita) que caem na nova tela por
// padrão. Incremente aos poucos para abrir o teste gradualmente.
//   0   = somente sob demanda (sem A/B);
//   10  = 10% dos usuários;
//   100 = todos.
// O rollout é monotônico: aumentar o valor só inclui mais usuários, nunca remove
// quem já estava na faixa.
export const OVERVIEW_ROLLOUT_PERCENTAGE = 10;

// Dispara um evento no Google Analytics (gtag), se disponível.
const trackEvent = (event: string, params?: Record<string, unknown>): void => {
  const gtag = (window as { gtag?: (...args: unknown[]) => void }).gtag;
  if (typeof gtag === "function") gtag("event", event, params || {});
};

export const enableNewExperience = (): void => {
  window.localStorage.setItem(OVERVIEW_EXPERIENCE_KEY, "new");
  trackEvent("overview_opt_in"); // clicou em "ver nova experiência"
};

export const disableNewExperience = (): void => {
  window.localStorage.setItem(OVERVIEW_EXPERIENCE_KEY, "old");
  trackEvent("overview_opt_out"); // clicou em "voltar para experiência anterior"
};

// Bucket estável 0–99, sorteado uma única vez por navegador e persistido. Como é
// fixo, aumentar o percentual de rollout inclui os usuários de forma monotônica.
const getAbBucket = (): number => {
  const stored = window.localStorage.getItem(OVERVIEW_AB_BUCKET_KEY);
  if (stored === null) {
    const drawn = Math.floor(Math.random() * 100);
    window.localStorage.setItem(OVERVIEW_AB_BUCKET_KEY, String(drawn));
    // Sorteio do teste A/B (acontece uma vez por navegador).
    trackEvent("overview_ab_assigned", {
      bucket: drawn,
      rollout: OVERVIEW_ROLLOUT_PERCENTAGE,
      variant: drawn < OVERVIEW_ROLLOUT_PERCENTAGE ? "new" : "old",
    });
    return drawn;
  }
  const bucket = parseInt(stored, 10);
  return Number.isNaN(bucket) ? 100 : bucket; // valor inválido nunca entra no rollout
};

// Decisão final de qual experiência mostrar (preferência explícita > rollout A/B).
export const isNewExperienceEnabled = (): boolean => {
  const preference = window.localStorage.getItem(OVERVIEW_EXPERIENCE_KEY);
  if (preference === "new") return true;
  if (preference === "old") return false;
  return getAbBucket() < OVERVIEW_ROLLOUT_PERCENTAGE;
};
